export function createRedirectUrl(
  baseUrl: string,
  accessToken: string,
  refreshToken: string,
  idToken: string,
  state: string | null
): string {
  let url = `${baseUrl}?access_token=${accessToken}&refresh_token=${refreshToken}&id_token=${idToken}`;
  if (state) {
    url = `${url}&state=${state}`;
  }
  return url;
}
